// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__oL2ot","container":"styles_container__31yyK","title":"styles_title__1UUKx","wrapper":"styles_wrapper__1RhXA","answer":"styles_answer__1JeIu"};